import axios from 'axios';
import { ApiResponse } from './types';

export const reInviteUser = async (
	email: string
): Promise<ApiResponse<any[]>> => {
	const response = await axios.post(
		`${import.meta.env.VITE_backend_api_url}/public/re-invite-owner`,
		{
			email,
		}
	);
	return response.data;
};

export const getLoginAttempts = async (
	email: string
): Promise<ApiResponse<any[]>> => {
	const response = await axios.get(
		`${import.meta.env.VITE_backend_api_url}/public/login-attempt`,
		{
			params: { email },
		}
	);
	return response.data.data;
};

export const addLoginAttempts = async (
	email: string,
	success: boolean
): Promise<ApiResponse<any[]>> => {
	const response = await axios.post(
		`${import.meta.env.VITE_backend_api_url}/public/login-attempt`,
		{
			email,
			success,
		}
	);
	return response.data;
};
